const SocketMessageReducers = (
  state = {
    show: false,
    message: "",
  },
  action
) => {
  switch (action.type) {
    case "SAVE_SOCKET_MESSAGE":
      return action.payload;
    case "CLEAR_SOCKET_MESSAGE":
      return { show: false, message: "" };
    default:
      return state;
  }
};
export default SocketMessageReducers;
